import React, { useRef, useEffect, useState } from "react";
import "./SharedReportStyles.css";
import "./ObservacionesComentarios.css";

const Comentarios = ({ seccion, updateItemResponse, renderCase }) => {
  // Comprobación de seguridad para evitar errores
  const items = seccion && seccion.items ? seccion.items : [];
  
  return (
    <div className="sr-section">
      <p className="sr-section-title">{seccion.nombreseccion}</p>
      <div className="oc-container">
        {items.map((item) => (
          <Item
            key={item.id || Math.random()}
            item={item}
            updateItemResponse={updateItemResponse}
            seccion={seccion.idseccionreporte}
            renderCase={renderCase}
          />
        ))}
        {/* Si no hay items, crear un textarea vacío */}
        {items.length === 0 && (
          <div className="item">
            <textarea
              className="oc-textarea"
              placeholder="Sin observaciones disponibles"
              readOnly
            ></textarea>
          </div>
        )}
      </div>
    </div>
  );
};

const Item = ({ item, updateItemResponse, seccion, renderCase }) => {
  return (
    <div className="item" style={{width: '100%'}}>
      <ItemInput
        item={item}
        updateItemResponse={updateItemResponse}
        seccion={seccion}
        renderCase={renderCase}
      />
    </div>
  );
};

const ItemInput = ({ item, updateItemResponse, seccion, renderCase }) => {
  const textareaRef = useRef(null);
  const [localRespuesta, setLocalRespuesta] = useState(item.respuesta || "");

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  }, [localRespuesta]);

  const handleInput = (e) => {
    const newValue = e.target.value;
    setLocalRespuesta(newValue);
    
    if (updateItemResponse) {
      updateItemResponse(
        seccion,
        item.id,
        item.idrespuestaitem,
        item.idrespuestabooleana,
        item.idrespuestanumerica,
        item.idrespuestatexto,
        item.idrespuestaimagen,
        newValue
      );
    }
  };

  if (renderCase === "view") {
    // Cambiamos el p por un pre para preservar los saltos de línea
    return (
      <pre className="oc-label oc-text-pre">
        {item.respuesta || "Sin comentarios"}
      </pre>
    );
  }
  if (renderCase === "create") {
    return (
      <textarea
        ref={textareaRef}
        className="oc-textarea"
        placeholder="Haz click para agregar comentarios..."
        value={localRespuesta}
        onInput={handleInput}
      ></textarea>
    );
  }
  
  // Para "newFormat" o cualquier otro caso, mostrar textarea de solo lectura
  return (
    <textarea
      ref={textareaRef}
      className="oc-textarea"
      placeholder="Vista previa de comentarios"
      style={{width: '100%'}}
      readOnly
    ></textarea>
  );
};

export default Comentarios;
